import Box from "glesys-controlpanel/components/box";
import Cost from "glesys-controlpanel/components/cost";
import IconsEye from "glesys-controlpanel/components/icons/eye";
import GButtonLink from "glesys-controlpanel/components/g-button/link";

import { t } from "ember-intl";

<template>
  <Box data-test-server-total-cost>
    <:default>
      <p class="text-gray-500 text-sm">{{t "title.total-cost"}}</p>
      <Cost
        class="mt-1"
        @currency={{@server.billing.currency}}
        @price={{@server.billing.price}}
        @discountedPrice={{@server.billing.total}}
      />
    </:default>
    <:footer>
      <GButtonLink @display="compact" href="#server-cost-summary">
        <div class="flex items-center">
          <IconsEye class="w-5 mr-1 -mt-px text-rebeccapurple-700" />
          {{t "server.details.view-breakdown"}}
        </div>
      </GButtonLink>
    </:footer>
  </Box>
</template>
